<template>
  <div class="dealers-container">
    <div class="dealers-content">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="Дилеры" name="dealers">
          <div class="dealers-actions">
            <el-button type="primary" @click="$router.push('/dealer-register')">
              + Добавить дилера
            </el-button>
            <el-button @click="fetchDealers" :loading="loading">
              Обновить
            </el-button>
          </div>

          <el-table :data="dealers" v-loading="loading" style="width: 100%">
            <el-table-column prop="id" label="ID" width="60"></el-table-column>
            <el-table-column label="Логотип" width="80">
              <template slot-scope="scope">
                <img
                  v-if="scope.row.logo"
                  :src="'https://forklifts.kz' + scope.row.logo"
                  class="dealer-logo-thumb"
                />
                <span v-else>—</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="Название"></el-table-column>
            <el-table-column prop="address" label="Адрес"></el-table-column>
            <el-table-column label="Ссылка" width="250">
              <template slot-scope="scope">
                <a :href="scope.row.dealer_url" target="_blank" class="dealer-link">
                  {{ scope.row.dealer_url }}
                </a>
              </template>
            </el-table-column>
            <el-table-column label="Действия" width="150">
              <template slot-scope="scope">
                <el-button size="mini" @click="openEditDialog(scope.row)">
                  Изменить
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="confirmDelete(scope.row)"
                >
                  Удалить
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="Коммерческие предложения" name="offers">
          <div class="dealers-actions">
            <el-select
              v-model="filterDealerId"
              placeholder="Фильтр по дилеру"
              clearable
              style="width: 250px; margin-right: 10px;"
              @change="fetchOffers(1)"
            >
              <el-option
                v-for="d in dealers"
                :key="d.id"
                :label="d.name"
                :value="d.id"
              ></el-option>
            </el-select>
            <el-button @click="fetchOffers()" :loading="offersLoading">
              Обновить
            </el-button>
          </div>

          <el-table :data="offers" v-loading="offersLoading" style="width: 100%">
            <el-table-column prop="id" label="ID" width="60"></el-table-column>
            <el-table-column prop="company_name" label="Компания" min-width="150"></el-table-column>
            <el-table-column label="Дата создания" width="120">
              <template slot-scope="scope">
                {{ formatDate(scope.row.created_at) }}
              </template>
            </el-table-column>
            <el-table-column label="Действует до" width="120">
              <template slot-scope="scope">
                {{ scope.row.valid_until }}
              </template>
            </el-table-column>
            <el-table-column prop="dealer_name" label="Дилер" width="150"></el-table-column>
            <el-table-column prop="dealer_phone" label="Телефон" width="140"></el-table-column>
            <el-table-column prop="product_name" label="Техника" min-width="150"></el-table-column>
            <el-table-column prop="price" label="Цена" width="120"></el-table-column>
            <el-table-column prop="delivery_time" label="Срок поставки" width="130"></el-table-column>
            <el-table-column label="Оплата" width="200">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.payment_terms" placement="top" v-if="scope.row.payment_terms">
                  <span class="truncate-text">{{ scope.row.payment_terms }}</span>
                </el-tooltip>
                <span v-else>—</span>
              </template>
            </el-table-column>
            <el-table-column label="" width="80">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="confirmDeleteOffer(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-container">
            <el-pagination
              background
              layout="prev, pager, next, sizes, total"
              :total="offersTotal"
              :page-size="offersPageSize"
              :page-sizes="[10, 20, 50, 100]"
              :current-page="offersPage"
              @current-change="handlePageChange"
              @size-change="handlePageSizeChange"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- Edit Dialog -->
      <el-dialog
        title="Редактирование дилера"
        :visible.sync="editDialogVisible"
        width="500px"
      >
        <el-form :model="editForm" :rules="rules" ref="editForm" label-width="100px">
          <el-form-item label="Название" prop="name">
            <el-input v-model="editForm.name"></el-input>
          </el-form-item>

          <el-form-item label="Адрес" prop="address">
            <el-input v-model="editForm.address" type="textarea" :rows="3"></el-input>
          </el-form-item>

          <el-form-item label="Логотип">
            <div class="logo-edit-container">
              <img
                v-if="logoPreview || editForm.logo"
                :src="logoPreview || editForm.logo"
                class="logo-preview-edit"
              />
              <el-upload
                action=""
                :auto-upload="false"
                :show-file-list="false"
                :on-change="handleLogoChange"
                accept="image/*"
              >
                <el-button size="small">Загрузить новый</el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">Отмена</el-button>
          <el-button type="primary" @click="saveDealer" :loading="saving">
            Сохранить
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const API_BASE = "https://forklifts.kz/api-crm";

export default {
  name: "DealersList",
  data() {
    return {
      activeTab: "dealers",
      dealers: [],
      loading: false,
      saving: false,
      editDialogVisible: false,
      editForm: {
        slug: "",
        name: "",
        address: "",
        logo: null,
      },
      newLogoFile: null,
      logoPreview: null,
      rules: {
        name: [
          { required: true, message: "Введите название компании", trigger: "blur" },
        ],
      },
      // Offers
      offers: [],
      offersLoading: false,
      offersTotal: 0,
      offersPage: 1,
      offersPageSize: 20,
      filterDealerId: null,
    };
  },
  mounted() {
    this.fetchDealers();
  },
  watch: {
    activeTab(val) {
      if (val === "offers" && this.offers.length === 0) {
        this.fetchOffers();
      }
    },
  },
  methods: {
    async fetchDealers() {
      this.loading = true;
      try {
        const response = await axios.get(`${API_BASE}/dealers/`);
        this.dealers = response.data;
      } catch (error) {
        console.error("Ошибка загрузки дилеров:", error);
        this.$notify.error({
          title: "Ошибка",
          message: "Не удалось загрузить список дилеров",
        });
      } finally {
        this.loading = false;
      }
    },

    openEditDialog(dealer) {
      this.editForm = {
        slug: dealer.slug,
        name: dealer.name,
        address: dealer.address || "",
        logo: "https://forklifts.kz"+dealer.logo,
      };
      this.newLogoFile = null;
      this.logoPreview = null;
      this.editDialogVisible = true;
    },

    handleLogoChange(file) {
      this.newLogoFile = file.raw;
      this.logoPreview = URL.createObjectURL(file.raw);
    },

    async saveDealer() {
      this.$refs.editForm.validate(async (valid) => {
        if (!valid) return;

        this.saving = true;
        const formData = new FormData();
        formData.append("name", this.editForm.name);
        formData.append("address", this.editForm.address);
        if (this.newLogoFile) {
          formData.append("logo", this.newLogoFile);
        }

        try {
          await axios.put(
            `${API_BASE}/dealers/${this.editForm.slug}/`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );

          this.$notify.success({
            title: "Успех",
            message: "Дилер успешно обновлён",
          });

          this.editDialogVisible = false;
          this.fetchDealers();
        } catch (error) {
          console.error("Ошибка при обновлении:", error);
          this.$notify.error({
            title: "Ошибка",
            message: error.response?.data?.detail || "Не удалось обновить дилера",
          });
        } finally {
          this.saving = false;
        }
      });
    },

    confirmDelete(dealer) {
      this.$confirm(
        `Удалить дилера "${dealer.name}"?`,
        "Подтверждение",
        {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отмена",
          type: "warning",
        }
      ).then(() => {
        this.deleteDealer(dealer);
      }).catch(() => {});
    },

    async deleteDealer(dealer) {
      try {
        await axios.delete(`${API_BASE}/dealers/${dealer.slug}/`);
        this.$notify.success({
          title: "Успех",
          message: "Дилер удалён",
        });
        this.fetchDealers();
      } catch (error) {
        console.error("Ошибка при удалении:", error);
        this.$notify.error({
          title: "Ошибка",
          message: "Не удалось удалить дилера",
        });
      }
    },

    // === Offers methods ===
    async fetchOffers(page) {
      if (page) this.offersPage = page;
      this.offersLoading = true;
      try {
        const params = {
          page: this.offersPage,
          page_size: this.offersPageSize,
        };
        if (this.filterDealerId) {
          params.dealer_id = this.filterDealerId;
        }
        const response = await axios.get(`${API_BASE}/dealer-offers/`, { params });
        this.offers = response.data.results;
        this.offersTotal = response.data.total;
      } catch (error) {
        console.error("Ошибка загрузки КП:", error);
        this.$notify.error({
          title: "Ошибка",
          message: "Не удалось загрузить список КП",
        });
      } finally {
        this.offersLoading = false;
      }
    },

    handlePageChange(page) {
      this.fetchOffers(page);
    },

    handlePageSizeChange(size) {
      this.offersPageSize = size;
      this.fetchOffers(1);
    },

    formatDate(dateStr) {
      if (!dateStr) return "—";
      const d = new Date(dateStr);
      return d.toLocaleDateString("ru-RU");
    },

    confirmDeleteOffer(offer) {
      this.$confirm(
        `Удалить КП для "${offer.company_name}"?`,
        "Подтверждение",
        {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отмена",
          type: "warning",
        }
      ).then(() => {
        this.deleteOffer(offer);
      }).catch(() => {});
    },

    async deleteOffer(offer) {
      try {
        await axios.delete(`${API_BASE}/dealer-offers/${offer.id}/`);
        this.$notify.success({
          title: "Успех",
          message: "КП удалено",
        });
        this.fetchOffers();
      } catch (error) {
        console.error("Ошибка при удалении КП:", error);
        this.$notify.error({
          title: "Ошибка",
          message: "Не удалось удалить КП",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.dealers-container {
  width: 100vw;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
  background: #f5f7fa;
}

.dealers-content {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  h2 {
    margin-bottom: 20px;
    color: #303133;
  }
}

.dealers-actions {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
}

.dealer-logo-thumb {
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 4px;
}

.dealer-link {
  color: #409eff;
  text-decoration: none;
  font-size: 12px;
  word-break: break-all;

  &:hover {
    text-decoration: underline;
  }
}

.logo-edit-container {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo-preview-edit {
  width: 80px;
  height: 80px;
  object-fit: contain;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.el-table {
  .el-button + .el-button {
    margin-left: 5px;
  }
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.truncate-text {
  display: block;
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
